import { render, staticRenderFns } from "./Feed.vue?vue&type=template&id=2a41291e"
import script from "./Feed.vue?vue&type=script&lang=js"
export * from "./Feed.vue?vue&type=script&lang=js"
import style0 from "./Feed.vue?vue&type=style&index=0&id=2a41291e&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a41291e')) {
      api.createRecord('2a41291e', component.options)
    } else {
      api.reload('2a41291e', component.options)
    }
    module.hot.accept("./Feed.vue?vue&type=template&id=2a41291e", function () {
      api.rerender('2a41291e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/Feed/Feed.vue"
export default component.exports